import React from 'react'
import Landing from '../components/Landing'

const LandingPage = () => {
    return (
        <div>
            <Landing/>
        </div>
    )
}

export default LandingPage
